import { LocationVarKey } from "@swivl-mono/types";

import { IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow,
} from "../../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../../Hooks/usePropertiesGetLocationIds";

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="Use this page to customize the spot review process for your customers. Set the page title, enable a disclaimer, and set the disclaimer text using HTML to format the text.">
        {" "}
        spot Review{" "}
      </PageHeader>

      <InputRow {...page} keyName={LocationVarKey.SpotReviewPageTitle} label="Page Title" />

      <SwitchRow {...page} keyName={LocationVarKey.SpotReviewDisclaimerEnabled} label="Include Disclaimer" />

      <TextAreaRow {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.SpotReviewDisclaimerEnabled, "1")} marginTop label="Disclaimer" keyName={LocationVarKey.SpotReviewDisclaimer} />
    </>
  );
}
